import React from "react";
import StryktipsetCreateForm from "./Stryktipset/StryktipsetCreateForm";
import EuropatipsetCreateForm from "./Europatipset/EuropatipsetCreateForm";
import V75CreateForm from "./V75/V75CreateForm";
import V86CreateForm from "./V86/V86CreateForm";

class TicketLayoutCreateForm extends React.Component {
  render() {
    const props = {...this.props};

    switch (this.props.selectInputState) {
      case "stryktipset":
        return <StryktipsetCreateForm {...props} />;

      case "europatipset":
        return <EuropatipsetCreateForm {...props} />;

      case "v75":
        return <V75CreateForm {...props} />;

      case "v86":
        return <V86CreateForm {...props} />;

      default:
        return <StryktipsetCreateForm {...props} />;
    }
  }
}

export default TicketLayoutCreateForm;



// WEBPACK FOOTER //
// ./src/containers/CRM/VirtualSlips/TicketLayouts/index.js